import * as React from 'react';
export const filterSvg = React.forwardRef(function filterSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.5 3.125c0-.483.392-.875.875-.875h13.25a.875.875 0 0 1 0 1.75H1.375A.875.875 0 0 1 .5 3.125ZM3 8.001c0-.483.392-.875.875-.875h8.25a.875.875 0 0 1 0 1.75h-8.25A.875.875 0 0 1 3 8.001Zm2 4.874c0-.483.392-.875.875-.875h4.25a.875.875 0 0 1 0 1.75h-4.25A.875.875 0 0 1 5 12.875Z',
    }),
  );
});
filterSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var filter = {
  category: 'icon',
  colorable: true,
  name: 'filter',
  svg: filterSvg,
};
